var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var AbstractEndpoint = require('../endpoint');

module.exports =
/*#__PURE__*/
function (_AbstractEndpoint) {
  "use strict";

  _inherits(ItemsEndpoint, _AbstractEndpoint);

  function ItemsEndpoint(client) {
    var _this;

    _classCallCheck(this, ItemsEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ItemsEndpoint).call(this, client));
    _this.url = '/v2/items';
    _this.isPaginated = true;
    _this.isBulk = true;
    _this.supportsBulkAll = false;
    _this.isLocalized = true;
    _this.cacheTime = 24 * 60 * 60;
    return _this;
  }

  return ItemsEndpoint;
}(AbstractEndpoint);